import { ErrorHandling } from "@sagecentral/core-ui";
import { PreferenceType } from "components/preferences";
import { ProjectPermissionsProvider, RequireProjectPermission } from "components/projects";
import { ProjectsGrid } from "components/projects/grid";
import Milestones from "components/projects/milestones/milestones";
import OverviewTasks from "components/projects/my-projects/overview";
import ProjectLayout from "components/projects/project-layout";
import { ProjectMyTasks } from "components/projects/tasks";
import WorkItemsWokflowsTabs from "components/projects/workitems-workflows/WorkitemsWorkflowsTabs";
import { NavigateDefaultTab } from "components/shared";
import { Navigate, Outlet, Route, Routes } from "react-router-dom";

const ProjectRoutes = () => (
    <ProjectPermissionsProvider>
        <Routes>
            <Route index element={<Navigate to="my/in-progress" replace={true} />} />
            <Route path="in-progress" element={<Navigate to="../my/in-progress" replace={true} />} />
            <Route path='my/*' element={
                <RequireProjectPermission permission="canViewMyProjectsDashboard">
                    <Outlet />
                </RequireProjectPermission>
            }>
                <Route index element={
                <NavigateDefaultTab
                    type={PreferenceType.MyProjectsDashboard}
                    fallback={
                    <Navigate to="in-progress" replace={true} />
                    } />
                } />
                <Route path="inprogress" element={<Navigate to="../in-progress" replace={true} />} />
                <Route path="in-progress" element={<ProjectsGrid Status="in-progress" />} />
                <Route path="upcoming" element={<ProjectsGrid Status="upcoming" />} />
                <Route path="cancelled" element={<ProjectsGrid Status="cancelled" />} />
                <Route path="onhold" element={<Navigate to="/projects/on-hold" />} />
                <Route path="on-hold" element={<ProjectsGrid Status="on-hold" />} />
                <Route path="completed" element={<ProjectsGrid Status="completed" />} />
                <Route path="all" element={<ProjectsGrid Status="all" />} />
                <Route path=":projectId/*" element={<ProjectLayout />}>
                <Route index element={<Navigate to="overview" replace={true} />} />
                <Route path='overview/' element={<OverviewTasks />} />
                <Route path='milestones/' element={<Milestones />} />
                <Route path="my/tasks" element={<ProjectMyTasks />} />
                <Route path="workitems-workflow/" element={<WorkItemsWokflowsTabs />} />
                </Route>
            </Route>
            <Route path='all/*' element={<RequireProjectPermission permission="canViewAllProjectsDashboard"><Outlet /></RequireProjectPermission>}>
                <Route index element={<ProjectsGrid Status="all" all={true} />} />
                <Route path="inprogress" element={<Navigate to="../in-progress" replace={true} />} />
                <Route path="in-progress" element={<ProjectsGrid Status="in-progress" all={true} />} />
                <Route path="upcoming" element={<ProjectsGrid Status="upcoming" all={true} />} />
                <Route path="cancelled" element={<ProjectsGrid Status="cancelled" all={true} />} />
                <Route path="onhold" element={<Navigate to="../on-hold" replace={true} />} />
                <Route path="on-hold" element={<ProjectsGrid Status="on-hold" all={true} />} />
                <Route path="completed" element={<ProjectsGrid Status="completed" all={true} />} />
                <Route path=":projectId/*" element={<ProjectLayout />}>
                <Route index element={<Navigate to="overview" replace={true} />} />
                <Route path='overview/' element={<OverviewTasks />} />
                <Route path='milestones/' element={<Milestones />} />
                <Route path="my/tasks" element={<ProjectMyTasks />} />
                <Route path="workitems-workflow/" element={<WorkItemsWokflowsTabs />} />
                <Route path="*" element={<ErrorHandling error={{ message: "Base error", name: "Error", cause: 404 }} />} />
                </Route>
                <Route path="*" element={<ErrorHandling error={{ message: "Base error", name: "Error", cause: 404 }} />} />
            </Route>
            <Route path="*" element={<ErrorHandling error={{ message: "Base error", name: "Error", cause: 404 }} />} />
        </Routes>
    </ProjectPermissionsProvider>
);

export default ProjectRoutes;